import { KYMW1800Model } from '../kymw1800.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
/**
 * 画像チェックリストを取得する
 *
 * @export getImageExistenceListService
 * @class GetImageExistenceListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetImageExistenceListService extends PlessJsonResponderSub<any> {

  vo = {
    orderCode: '',
    mediumType: '',
    delivCatalogId: '',
    outputType: '',
    coopCodeList: []
  };

  // 処理に使用するModel
  private model: KYMW1800Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストXML
   * @memberof GetImageExistenceListService
   */
  private getBody(): PlessRequest {
    const combinations = this.vo.coopCodeList.map(coopCode => ({
      condition: {
        CoopCode: coopCode
      }}));

    return new PlessRequest({
      search: {
        ImageExistenceList: {
          condition: {
            OrderCode: this.vo.orderCode,
            MediumType: this.vo.mediumType,
            DelivCatalogId: this.vo.delivCatalogId,
            OutputType: this.vo.outputType,
          },
          combination: combinations
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetImageExistenceListService
   */
  execute(model: KYMW1800Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getImageExistenceList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetImageExistenceListService
   */
  success(data: any): void {
    // レスポンスのファイルパスをマネージに保存
    this.model.updateFileName(data);
    if (data !== null) {
      this.successFunc(data);
    }
  }

}
